/**
 * old version of extensible form panel. it's NOT RECOMMENDED to extend this class, when creating new form.
 */
mx.comp.ExtensibleFormPanel = Ext.extend(mx.comp.FormPanel, {
    buildFormItems: function() {
        return [];
    },
    buildColumnsLayout: function() {
        return [
            {
                columnWidth: 0.5,
                border: false,
                header: false,
                layout: 'mx-form',
                defaults: {anchor: '-5'},
                id: 'LeftPanel',
                items: [],
            },
            {
                columnWidth: 0.5,
                border: false,
                header: false,
                layout: 'mx-form',
                defaults: {anchor: '-5'},
                id: 'RightPanel',
                items: [],
            },
        ];
    },
    buildForm: function() {
        var formItems = (this.formItems = this.buildFormItems());

        // sort items by order:
        this.formItems.sort(function(a, b) {
            if (a != null && b != null) {
                var orderA = a.order === undefined ? formItems.indexOf(a) : a.order;
                var orderB = b.order === undefined ? formItems.indexOf(b) : b.order;
                return orderA - orderB;
            } else {
                return 0;
            }
        });

        var getItemsForColumn = function(col) {
            var items = [];
            //            var names = [];
            for (var i = 0, l = this.formItems.length; i < l; i++) {
                if (this.formItems[i] != null) {
                    if (
                        (!this.formItems[i]['column'] && col == 0) ||
                        (this.formItems[i]['column'] && this.formItems[i].column == col)
                    ) {
                        //                        names.push(this.formItems[i]['name']);
                        items.push(this.formItems[i]);
                    }
                }
            }
            return items;
        };

        // columns
        var formColumns = [];
        var columns = this.buildColumnsLayout();
        for (var i = 0, l = columns.length; i < l; i++) {
            if (columns[i].items) {
                columns[i].items = getItemsForColumn.call(this, i);
                formColumns.push(columns[i]);
            }
        }
        return formColumns;
    },
    initComponent: function() {
        mx.comp.ExtensibleFormPanel.superclass.initComponent.apply(this, arguments);
        var columns = this.buildForm();
        this.add(columns[0], columns[1]);
    },
});
